<template>
  <div class="notice dialog" v-if="show">
    <div class="content">
      <div @click="close" class="close"></div>
      <img class="background" src="https://vanthink-dev.oss-cn-qingdao.aliyuncs.com/ec81bc5ef87e5a8a5821bb4f84867d79.png" alt="">
      <div
        :class="{ 'single': match.guard && match.guard.length === 1 }"
        class="guard-list list">
        <div
          class="item"
          v-for="item in match.guard"
          :key="item.id">
          <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8d32ca106e52e2fb36a4496ca139ffc2.png" alt="">
          <div class="name">{{item.name}}</div>
        </div>
      </div>
      <div
        :class="{ 'single': match.offensive && match.offensive.length === 1 }"
        class="offensive-list list">
        <div
          class="item"
          v-for="item in match.offensive"
          :key="item.id">
          <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/637592faf7d97b67dd349cb4a3751c4d.png" alt="">
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/graphql/match';
import utils from '@/services/utils';
import { CHECK_MATCH_LOOP } from './const';

export default {
  data() {
    return {
      match: {},
      timer: null,
      show: false,
      delayCloseTimer: null,
    };
  },
  created() {
    this.loopCheckMatch();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.delayCloseTimer);
  },
  methods: {
    checkMatch() {
      api.checkMatch().then(({ checkMatch }) => {
        const preMatchInfo = utils.storage('match_info');

        if (checkMatch.id) {
          this.match = checkMatch;
          if (!preMatchInfo) {
            // 缓存没有比赛弹出提示
            this.show = true;
            this.delayCloseTimer = setTimeout(() => {
              utils.storage('match_info',
                {
                  match_id: checkMatch.id,
                });
              this.show = false;
            }, 5000);
          } else if (preMatchInfo.match_id !== checkMatch.id) {
            // 缓存有比赛 进行比较 弹出提示
            this.show = true;
            this.delayCloseTimer = setTimeout(() => {
              utils.storage('match_info',
                {
                  match_id: checkMatch.id,
                });
              this.show = false;
            }, 5000);
          }
        } else {
          utils.storage('match_info', null);
        }
      });
    },
    close() {
      if (this.delayCloseTimer) {
        clearTimeout(this.delayCloseTimer);
      }
      utils.storage('match_info',
        {
          match_id: this.match.id,
        });
      this.show = false;
    },
    loopCheckMatch() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.timer = setInterval(() => {
        this.checkMatch();
      }, CHECK_MATCH_LOOP);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/styles/common/dialog.scss";
  .notice {
    width: 80vw;
    z-index: 9999;
    .content {
      position: relative;
      overflow: hidden;
      .background {
        width: 100%;
      }
      .guard-list {
        position: absolute;
        top: 40%;
        left: 8%;
      }
      .offensive-list {
        position: absolute;
        top: 40%;
        right: 8%;
      }
      .single {
        text-align: center;
      }
      .list {
        width: 30%;
        height: 55%;
        overflow-y: auto;
        .item {
          margin: 0 10px;
          display: inline-block;
          position: relative;
          width: 10vw;
          height: 5.26vw;
          img {
            width: 100%;
            height: 100%;
          }
          .name {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 8vw;
            font-size: 2vh;
            color: #fff;
            text-align: center;
            transform: translate(-50%, -50%);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
</style>
